export const environment = {
    production: false,
    apiUrl: "//system4-dev.rekbot.pl",
    apiKey: "R8c7b324dgs12KL",
    authToken: "79ditgdw1n0kAJMXqAUVVuKHwqHDvoQ3iSaktJHI296d0e9a"
  };
  